<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full">
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="12" :md="12">
            <a-button
              type="primary"
              icon="plus"
              size="small"
              @click="UserAddClick"
            >
              新增
            </a-button>
          </a-col>
          <a-col
            :span="12"
            :md="12"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-input
              v-model="skey"
              placeholder="用户名/电话"
              size="small"
              style="width: 150px; margin-right: 10px"
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              @click="GetTableData()"
            >
              查询
            </a-button>
          </a-col>
        </a-row>
      </template>

      <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
        size="small"
      >
        <template slot="author" slot-scope="row">
          <div class="table-avatar-info">
            <a-avatar shape="square" :src="row.avatar" />
            <div class="avatar-info">
              <h6>{{ row.userName }}</h6>
              <p>{{ row.userPhone }}</p>
            </div>
          </div>
        </template>

        <template slot="userRole" slot-scope="row">
          <el-tag size="small" :type="getTagType(row)">{{ row.userRole }}</el-tag>
        </template>

        <!-- <template slot="func" slot-scope="func">
          <div class="author-info">
            <h6 class="m-0">{{ func.job }}</h6>
            <p class="m-0 font-regular text-muted">{{ func.department }}</p>
          </div>
        </template> -->

        <template slot="editBtn" slot-scope="row">
          <a-button
            type="primary"
            icon="edit"
            shape="round"
            :data-id="row.id"
            size="small"
            style="margin-right: 10px"
            @click="UserEditClick(row)"
            >编辑</a-button
          >
          <a-button
            type="danger"
            icon="delete"
            shape="round"
            :data-id="row.id"
            size="small"
            @click="UserDelClick(row)"
            >删除</a-button
          >
        </template>
      </a-table>

      <div class="PageCom">
        <el-pagination
          background
          :current-page="Page.index"
          :page-sizes="Page.sizes"
          :page-size="Page.size"
          :total="Page.total"
          layout="total, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </a-card>
  </div>
</template>

<script>
import { getUserList, userDel } from "@/api/user";
export default {
  data() {
    return {
      skey: "",
      columns: [
        {
          title: "用户",
          key: "author",
          scopedSlots: { customRender: "author" },
        },
        {
          title: "角色",
          key: "userRole",
          scopedSlots: { customRender: "userRole" },
        },
        { title: "创建日期", dataIndex: "createTime", key: "createTime" },
        { title: "登录时间", dataIndex: "lastLoginTime", key: "lastLoginTime" },
        {
          title: "操作",
          key: "editBtn",
          scopedSlots: { customRender: "editBtn" },
        },
      ],
      tableData: [],
      Page: {
        index: 1,
        size: 10,
        sizes: [10, 20, 50, 100],
        total: 0,
      },
      selUserMod: {
        id: "",
      },
    };
  },
  created() {
    this.GetTableData();
  },
  methods: {
    handleSizeChange(val) {
      this.Page.size = val;
      this.GetTableData();
    },
    handleCurrentChange(val) {
      this.Page.size = val;
      this.GetTableData();
    },
    GetTableData() {
      getUserList(this.skey, this.Page.index, this.Page.size).then((res) => {
        this.tableData = res.data.data.map((v) => {
          if (v.avatar == null || v.avator == "") {
            v.avatar = "images/face-2.jpg";
          }
          return v;
        });

        this.Page.total = res.data.total;
        console.log(res);
      });
    },
    UserAddClick() {
      this.selUserMod = {
        id: "",
        userName: "",
        userPhone: "",
        password: "",
        repassword: "",
      };
      this.$emit("useredit", this.selUserMod);
    },
    UserEditClick(row) {
      this.selUserMod = Object.assign(row);
      this.$emit("useredit", this.selUserMod);
    },
    UserDelClick(row) {
      this.$confirm("此操作将永久删除此用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          userDel(row.id).then((res) => {
            if (res.data.code == 0) {
              this.$message.success(res.msg);
              this.GetTableData();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    getTagType(row){
      if(row.userRole=="管理员"){
        return ""
      }
      else if(row.userRole=="普通用户"){
        return "info"
      }
      else{
        return "danger"
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>